<template>
  <div>
    <add-Button
      :height="'100px'"
      :add-text="'新增开票信息'"
      style="margin-bottom:20px;"
      @click.native="addBilling"
    ></add-Button>

    <div class="billing-item" v-for="item in billingList" :key="item.id">
      <div class="title">
        <div class="icon-container" :style="{backgroundColor:getRandomColor()}">
          <svg-icon icon-class="tags" class="icon" />
        </div>
        企业名称：{{item.enterpriseName}}
      </div>
      <el-row class="content">
        <el-col :span="10">
          <p>
            税号：
            <span>{{item.taxNumber}}</span>
          </p>
          <p>
            地址：
            <span>{{item.address}}</span>
          </p>
          <p>
            电话：
            <span>{{item.phoneNumber}}</span>
          </p>
        </el-col>
        <el-col :span="10">
          <p>
            银行账户：
            <span>{{item.bankAccount}}</span>
          </p>
          <p>
            可见范围：
            <span>全员可见</span>
          </p>
          <p>
            备注：
            <span>{{item.remark}}</span>
          </p>
        </el-col>
        <el-col :span="4" style="text-align:right;">
          <p>操作</p>
          <div class="action">
            <el-button type="text" @click="modifyBilling(item.id)">编辑</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" @click="deleteInvoice(item.id)">删除</el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
    </div>

    <!-- dialog -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form
        :model="billingForm"
        :rules="rules"
        ref="billingForm"
        label-width="100px"
        class="billingForm"
      >
        <el-form-item label="企业名称" prop="enterpriseName">
          <el-input v-model="billingForm.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="taxNumber">
          <el-input v-model="billingForm.taxNumber"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="billingForm.address"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phoneNumber">
          <el-input v-model="billingForm.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="bankAccount">
          <bank-account v-model="billingForm.bankAccount" ref="bankAccountNumber" />
        </el-form-item>
        <el-form-item label="开户行" prop="openingBank">
          <bank-account-type
            v-model="billingForm.openingBank"
            class="bank-account-type"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="billingForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmitBillingForm">取 消</el-button>
        <el-button type="primary" @click="confirmSubmitBillingForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bankName from "@/view/management/bankAccount/bankName.json";
import AddButton from "@/components/AddButton/AddButton";
import BankAccount from "@/components/BankAccount/BankAccount";
import BankAccountType from "@/components/BankAccount/BankAccountType";

import { mapGetters } from "vuex";
import {getRandomColor} from "@/prototypeMethods/methods"

const initBilling = {
  enterpriseName: "",
  taxNumber: "",
  address: "",
  phoneNumber: "",
  openingBank: "",
  bankAccount: "",
  remark: ""
};

export default {
  components: {
    AddButton,
    BankAccount,
    BankAccountType
  },
  data() {
    return {
      billingList: [],
      getRandomColor: getRandomColor,
      dialogVisible: false,
      billingForm: this.$js.deepClone(initBilling),
      rules: {
        enterpriseName: [
          { required: true, message: "企业名字不能为空", trigger: "blur" },
          { max: 50, message: "企业名字不能超过50个字符", trigger: "blur" }
        ],
        taxNumber: [
          {
            required: true,
            message: "纳税人识别号不能为空",
            trigger: "blur"
          },
          {
            required: true,
            message: "纳税人识别号由15位、17位、18或者20位码(字符型)组成",
            trigger: "blur"
            // pattern: /^[A-HJ-NP-RT-UW-Y0-9]{15}$|^[A-HJ-NP-RT-UW-Y0-9]{17}$|^[A-HJ-NP-RT-UW-Y0-9]{18}$|^[A-HJ-NP-RT-UW-Y0-9]{20}$/
          }
        ],
        openingBank: [{ required: true, message: "开户行不能为空", trigger: "blur" }],
        address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        phoneNumber: [
          {
            required: true,
            message: "联系方式不能为空",
            trigger: "blur"
          },
          {
            required: true,
            message: "请正确的输入联系方式(固定电话或者手机号码)",
            trigger: "blur",
            pattern: /^\d{7,15}$/
          }
        ],
        bankAccount: [
          {
            required: true,
            message: "请输入银行账户！",
            trigger: "blur"
          },
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["currentEnterprise"]),
    submitBillingFormConfig() {
      if (this.billingForm.id) {
        return {
          api: this.$api.updateInvoice,
          tooltip: "修改"
        };
      } else {
        return {
          api: this.$api.addInvoice,
          tooltip: "添加"
        };
      }
    }
  },
  created() {
    this.setBillingList();
  },
  methods: {
    setBillingList() {
      this.$api.getAllInvoices(this.currentEnterprise.id).then(data => {
        this.billingList = data;
      });
    },

    modifyBilling(id) {
      this.$api.queryInvoice(id).then(billing => {
        this.billingForm = billing;
        this.dialogVisible = true;
      });
    },

    deleteInvoice(id) {
      this.$api.deleteInvoice(id).then(_=> {
        this.$message.success("删除成功！");
        this.setBillingList();
      })
    },

    addBilling() {
      this.dialogVisible = true;
    },

    handleClose(done) {
      this.clearBillingForm();
      done();
    },

    cancelSubmitBillingForm() {
      this.clearBillingForm();
      this.dialogVisible = false;
    },

    confirmSubmitBillingForm() {
      this.$refs.billingForm.validate(valid => {
        if (valid) {
          this.submitBillingForm();
        } else {
          return false;
        }
      });
    },

    submitBillingForm() {
      let billingForm = this.$js.deepClone(this.billingForm);
      billingForm.bankAccount = this.$refs.bankAccountNumber.reallyBankAccount;

      this.submitBillingFormConfig.api(this.billingForm).then(() => {
        this.$Message.success(`${this.submitBillingFormConfig.tooltip}成功`);
        this.setBillingList();
        this.dialogVisible = false;
        this.clearBillingForm();
      });
    },

    clearBillingForm() {
      this.billingForm = this.$js.deepClone(initBilling);
      this.$refs.billingForm.clearValidate();
    }
  }
};
</script>

<style scoped lang="scss">
.billing-item {
  padding: 15px;

  .title {
    height: 34px;
    line-height: 34px;
    font-weight: bolder;
    color: #515a6e;
    font-family: "PingFang SC";
    font-size: 16px;
    margin-bottom: 10px;

    .icon-container {
      font-size: 16px;
      height: 34px;
      width: 34px;
      float: left;
      border-radius: 17px;
      text-align: center;
      line-height: 34px;
      margin-right: 10px;
      color: #fff;
    }
  }

  .content {
    p {
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #515a6e;
    }

    .el-divider--vertical {
      height: 15px;
    }
  }
}
</style>
